import { css, cx } from 'emotion';
import {
	grey,
	headingXLarge,
	mobileMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	textBlock,
} from 'inside-out/global-styles';
import LeftBG from 'inside-out/images/log-in/left-bg.svg';
import RightBG from 'inside-out/images/log-in/right-bg.svg';

export const wrapperStyle = css({
	[`@media (min-width: ${mobileMaxWidthBreakpoint + 1}px)`]: {
		backgroundImage: `url(${LeftBG}), url(${RightBG})`,
		backgroundPosition: 'top left, bottom right',
		backgroundRepeat: 'no-repeat',
		minHeight: '652px',
		padding: '100px 0 0 0',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		padding: '15px 0',
	},
});

export const innerWrapperStyle = css({
	maxWidth: '500px',
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		padding: '0 10px',
	},
});

export const introParagraphStyle = cx(
	textBlock,
	css({
		marginBottom: '60px',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			marginBottom: '30px',
		},
	})
);

export const titleStyle = cx(
	headingXLarge,
	css({
	})
);

export const checkboxWrapStyle = css({
	color: grey,
	fontSize: '12px',
	lineHeight: '15px',
	marginBottom: '45px',
	'& input': {
		verticalAlign: 'middle',
	},
	'& span': {
		display: 'inline-block',
		marginLeft: '10px',
		verticalAlign: 'bottom',
	},
});

export const formBottomStyle = css({
	'& div:first-child': {
		float: 'left',
	},
	'& div:last-child': {
		float: 'right',
		'& a': {
			textDecoration: 'none',
			color: grey,
			fontSize: '12px',
			lineHeight: '15px',
		},
	},
	'&:after': {
		clear: 'both',
		display: 'block',
		content: '" "',
	},
});



// WEBPACK FOOTER //
// ./src/page-styles/log-in/index.js